export function getModalContent(data: { hubName?: string; isKioskless?: boolean }): ModalContent {
  return {
    title: 'Switch Space',
    promptMessage: 'Where are you moving the item to?',
    inputLabel: 'Space',
    callToActionLabel: 'Update',
    successLabel: 'Done',
    successMessage: 'The space has been switched.',
    cancelLabel: 'Cancel',
    closeLabel: 'Close',
    actionLabelLine1: data.isKioskless ? 'Updating' : 'Sending the request to',
    actionLabelLine2: data.isKioskless ? '' : `${data.hubName || 'the selected'} hub`
  };
}

export interface ModalContent {
  title: string;
  promptMessage: string;
  inputLabel: string;
  callToActionLabel: string;
  actionLabelLine1: string;
  actionLabelLine2: string;
  successLabel: string;
  cancelLabel: string;
  closeLabel: string;
  successMessage: string;
}
